import { Select } from 'antd'

import { RealBizTypeOptions } from '../../enums/BizType'

import { RealBizTypeSelectProps } from './interface'

export const RealBizTypeSelect = (props: RealBizTypeSelectProps) => {
  return <Select {...props} options={RealBizTypeOptions} />
}
